import UniversalIconBtn from '../../shared/component/headless/button/UniversalIconBtn';
import React from 'react';
import styled from 'styled-components';
import { useEditMode } from '../../shared/hooks/useEditMode';
import HintWrapper from '../../shared/component/headless/button/HintWrapper';
import { getHintMessage } from '../../shared/constants/hintMessages';
import seeIcon from '../../asset/icon/see.png';
import editIcon from '../../asset/icon/edit.png';
import { useUnsavedChanges } from '../../shared/hooks/useUnsavedChanges';
import { useCheckBeforeMove } from '../../shared/hooks/useCheckBeforeMove';
import { useAuth } from '../../shared/hooks/useApi/useAuth';
import { useDeviceStore } from '../../shared/store/deviceStore';
import { DeviceType } from '../../shared/enum/EnumRepository';
import { bottomWithSafeArea } from '../../shared/constants/safeArea';

const RightBottomIsland: React.FC = () => {
  const { isOwner } = useAuth();
  const { requestExitEditMode } = useUnsavedChanges();
  const { isEditMode, setEditMode } = useEditMode();
  const { getCurrentPage } = useCheckBeforeMove();
  const { page } = getCurrentPage();
  const { deviceType } = useDeviceStore();

  if (page === 'landing' || page === 'settings' || page === 'policy' || page === 'guide' || page === 'ADMIN' || page === 'poll' || page === 'onboard')
    return null;

  const toggleEditMode = () => {
    if (!isEditMode) {
      setEditMode(true);
    } else {
      requestExitEditMode();
    }
  };

  return (
    <GnbSection $isMobile={deviceType === DeviceType.MOBILE}>
      {isOwner ?
        <HintWrapper
          content={isEditMode ? getHintMessage('VIEW_MODE_CMD_E') : getHintMessage('EDIT_MODE_CMD_E')}
          toLeft={true}
        >
          <UniversalIconBtn
            size="standard"
            border={true}
            backgroundImg={isEditMode ? seeIcon : editIcon}
            onClick={toggleEditMode}
            aria-label={isEditMode ? getHintMessage('VIEW_MODE_CMD_E') : getHintMessage('EDIT_MODE_CMD_E')}
            aria-pressed={isEditMode}
          />
        </HintWrapper>
        : null
      }
    </GnbSection>
  );
}

const GnbSection = styled.section<{ $isMobile: boolean }>`
  position: fixed;
  bottom: ${({ $isMobile }) =>
    $isMobile
      ? bottomWithSafeArea('clamp(30px, 7vw, 40px)')
      : 'clamp(25px, 5vh, 50px)'};
  right: ${({ $isMobile }) => $isMobile ? 'clamp(18px, 5vw, 24px)' : 'clamp(20px, 2vw, 30px)'};

  display: flex;
  align-items: center;
  z-index: 4;
`;

export default RightBottomIsland;
